import { render } from "./BaseMobileOption.vue?vue&type=template&id=dbcaac98&scoped=true"
import script from "./BaseMobileOption.vue?vue&type=script&lang=js"
export * from "./BaseMobileOption.vue?vue&type=script&lang=js"

import "./BaseMobileOption.vue?vue&type=style&index=0&id=dbcaac98&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbcaac98"]])

export default __exports__